const API_BASE = ''

export async function createLedger(initial: { project_name: string; intention: string }) {
  const res = await fetch(`${API_BASE}/api/ledgers`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(initial),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateLedgerSection(ledgerId: string, secret: string, section: string, value: any) {
  const res = await fetch(`${API_BASE}/api/ledgers/${ledgerId}/section`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'x-owner-secret': secret },
    body: JSON.stringify({ section, value }),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function closeLedger(ledgerId: string, secret: string, payload: any) {
  const res = await fetch(`${API_BASE}/api/ledgers/${ledgerId}/close`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'x-owner-secret': secret },
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function getLedgerPrivate(ledgerId: string, secret: string) {
  const res = await fetch(`${API_BASE}/api/ledgers/${ledgerId}?k=${encodeURIComponent(secret)}`)
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function archiveCardPng(ledgerId: string, secret: string, pngBlob: Blob) {
  const form = new FormData()
  form.append('png', pngBlob, 'card.png')
  const res = await fetch(`${API_BASE}/api/cards/${ledgerId}/archive`, {
    method: 'POST',
    headers: { 'x-owner-secret': secret },
    body: form,
  })
  if (!res.ok) throw new Error(await res.text())
  const data = await res.json()
  return data.url as string
}

export async function getCheckin(token: string) {
  const res = await fetch(`${API_BASE}/api/checkin/${token}`)
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function recordActuals(token: string, actuals: string) {
  const res = await fetch(`${API_BASE}/api/checkin/${token}/actuals`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ actuals }),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function generateIcs(ledgerId: string, secret: string, days: number) {
  const res = await fetch(`${API_BASE}/api/ledgers/${ledgerId}/ics?k=${encodeURIComponent(secret)}&days=${days}`)
  if (!res.ok) throw new Error(await res.text())
  return res.blob()
}
